

import React, { useEffect, useState, useCallback } from 'react';
import './Tablemenu.css';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import toast from 'react-hot-toast';
import { BsInfoCircleFill } from "react-icons/bs";

const ShoppingCartIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
    </svg>
);

const CloseIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
);

const MenuitemsTable = ({ setShowLogin }) => {
    const location = useLocation();
    const navigate = useNavigate();

    const [seatingContext, setSeatingContext] = useState(null);
    const [isFromAddItem, setIsFromAddItem] = useState(false);

    const [dishes, setDishes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isVegSelected, setIsVegSelected] = useState(false);
    const [isNonVegSelected, setIsNonVegSelected] = useState(false);
    const [activeTooltip, setActiveTooltip] = useState(null);
    const [description, setDescription] = useState("");
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredDishes, setFilteredDishes] = useState([]);
    const [favorites, setFavorites] = useState([]);

    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("ALL");

    // ✅ Cart panel — always open on desktop, toggle on mobile
    const [isCartPanelOpen, setIsCartPanelOpen] = useState(false);

    const [cartItems, setCartItems] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [gstTotal, setGstTotal] = useState(0);
    const [serviceCharges, setServiceCharges] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [tableCode, setTableCode] = useState("");
    const [notes, setNotes] = useState({});
    const [allReady, setAllReady] = useState(false);
    const [cartId, setCartId] = useState(null);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [appliedCoupon, setAppliedCoupon] = useState(false);
    const [couponId, setCouponId] = useState(null);

    const [showGstPopup, setShowGstPopup] = useState(false);
    const [gstBreakdownData, setGstBreakdownData] = useState(null);

    const [showPaymentOptions, setShowPaymentOptions] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
    const [selectedWalletType, setSelectedWalletType] = useState("");
    const [orderId, setOrderId] = useState(null);
    const [availableBalance, setAvailableBalance] = useState(0);
    const [availableCompany, setAvailableCompany] = useState(0);
    const [availableSelf, setAvailableSelf] = useState(0);
    const [availableCashback, setAvailableCashback] = useState(0);
    const [orderPlacing, setOrderPlacing] = useState(false);
    const [showPaymentData, setShowPaymentData] = useState(false);

    const [isScheduleModalOpen, setIsScheduleModalOpen] = useState(false);
    const [scheduleDate, setScheduleDate] = useState("");
    const [scheduleTime, setScheduleTime] = useState("");
    const [guestName, setGuestName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [numberOfGuests, setNumberOfGuests] = useState(2);
    const [durationMinutes, setDurationMinutes] = useState(2);
    const [bookingLoading, setBookingLoading] = useState(false);
    const [bookingSuccess, setBookingSuccess] = useState(false);
    const [bookingDetails, setBookingDetails] = useState(null);
    const [waitingListMessage, setWaitingListMessage] = useState(null);

    const [parentId, setParentId] = useState(null);
    const [allDishes, setAllDishes] = useState([]);
    const [isWalletChecked, setIsWalletChecked] = useState(false);
    const [isCashChecked, setIsCashChecked] = useState(false);
    const [isOnlineChecked, setIsOnlineChecked] = useState(false);
    const [showWalletOptions, setShowWalletOptions] = useState(false);
    const [serviceApplied, setServiceApplied] = useState(true);
    const [currentSeatingId, setCurrentSeatingId] = useState(null);
    const [cartLoading, setCartLoading] = useState(false);
    const [quantities, setQuantities] = useState({});

    const getAuthVars = () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const vendorId = localStorage.getItem("vendorId");
        return { userId, token, vendorId };
    };

    useEffect(() => {
        const state = location.state;
        if (state && state.seatingId) {
            setIsFromAddItem(true);
            setSeatingContext(state);
            setCurrentSeatingId(state.seatingId);
            setTableCode(state.tableCode || "");
        } else {
            setIsFromAddItem(false);
            setSeatingContext(null);
            setCurrentSeatingId(null);
        }
    }, [location]);

    useEffect(() => {
        const handleResize = () => {
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (!mobile) setIsCartPanelOpen(false);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const fetchWalletData = useCallback(async () => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/subscription/api/user/wallet/${userId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = response.data || {};
            setAvailableBalance(data.totalBalance || 0);
            setAvailableCompany(data.companyLoadedAmount || 0);
            setAvailableSelf(data.selfLoadedAmount || 0);
            setAvailableCashback(data.cashbackAmount || 0);
        } catch (error) {
            console.error("Wallet API Error:", error);
        }
    }, []);

    useEffect(() => {
  const fetchCategories = async () => {
    const userId = localStorage.getItem("userId");
    const vendorId = localStorage.getItem("vendorId");

    if (!userId || !vendorId) return;

    setCategoriesLoading(true);

    try {
      const response = await axios.get(
        `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`
      );

      const data = Array.isArray(response.data) ? response.data : [];

      setCategories(buildCategoryTree(data));   // 👈 IMPORTANT FIX
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    } finally {
      setCategoriesLoading(false);
    }
  };

  fetchCategories();
//   fetchAddresses();
}, []);

const buildCategoryTree = (data) => {
  const map = new Map();

  data.forEach((item) => {
    const isParent = !item.parentId || item.parentId === 0;

    if (isParent) {
      map.set(item.dishId, {
        ...item,
        subCategories: []
      });
    }
  });

  data.forEach((item) => {
    const isChild = item.parentId && item.parentId !== 0;

    if (isChild && map.has(Number(item.parentId))) {
      map.get(Number(item.parentId)).subCategories.push(item);
    }
  });

  return Array.from(map.values());
};

    useEffect(() => {
  if (!Array.isArray(allDishes)) return;

  let filtered = [...allDishes];

  // STEP 1: CATEGORY FILTER
  if (selectedCategory && selectedCategory !== "ALL") {
    filtered = filtered.filter(
      item => Number(item.parentId) === Number(selectedCategory)
    );
  }

  // STEP 2: SEARCH FILTER
  const searchValue = searchTerm?.toLowerCase().trim() || "";
  if (searchValue) {
    filtered = filtered.filter(
      item =>
        item?.dishName &&
        item.dishName.toLowerCase().includes(searchValue)
    );
  }

  // STEP 3: VEG / NON-VEG FILTER
  if (isVegSelected) {
    filtered = filtered.filter(item => item?.tag === "Veg");
  } else if (isNonVegSelected) {
    filtered = filtered.filter(item => item?.tag === "Non_Veg");
  }

  // STEP 4: STATUS FILTER
  filtered = filtered.filter(item => item?.menuStatus === "Enable");

  setFilteredDishes(filtered);
  setDishes(filtered);
}, [
  selectedCategory,
  searchTerm,
  isVegSelected,
  isNonVegSelected,
  allDishes,
  categories
]);

    useEffect(() => {
        const fetchData = async () => {
            const { token, userId } = getAuthVars();
            const vendorId = localStorage.getItem("vendorId");
            if (!vendorId || !token || !userId) {
                setError(new Error("Missing required data"));
                setLoading(false);
                return;
            }
            try {
                const response = await fetch(
                    `https://backend.maamaas.com/food/api/dish/getby/vendor/user/dishes?vendorId=${vendorId}&userId=${userId}`,
                    { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
                );
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
                setAllDishes(Array.isArray(data) ? data : data.data || []);
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const fetchCartDetails = useCallback(async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        if (!userId) return;
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/get/user/with-seating?userId=${userId}`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            const cartData = response.data;
            let items = [];
            let cart = null;
            if (Array.isArray(cartData) && cartData.length > 0) {
                cart = cartData[0];
                items = cart.cartItems || [];
                if (cart.cartId) {
                    setCartId(cart.cartId);
                    localStorage.setItem("cartId", cart.cartId);
                }
                if (cart.seatingId) {
                    setCurrentSeatingId(cart.seatingId);
                    localStorage.setItem("seatingId", cart.seatingId);
                }
                if (cart.tableCode) setTableCode(cart.tableCode);
                localStorage.setItem("tableCode", cart.tableCode);
            }
            setCartItems(items);
            const initialQuantities = {};
            items.forEach(item => {
                const itemId = item.itemId || item.cartItemId;
                if (itemId) initialQuantities[itemId] = item.quantity || 1;
            });
            setQuantities(initialQuantities);
            if (cart) {
                calculateTotals(items, {
                    subtotal: cart.subtotal,
                    gstTotal: cart.gstTotal,
                    grandTotal: cart.grandTotal,
                    platformCharges: cart.platformCharges
                });
            } else {
                calculateTotals(items);
            }
        } catch (error) {
            console.error("Error fetching cart:", error.response?.data || error.message);
            setCartItems([]);
        }
    }, []);

    const calculateTotals = useCallback((items) => {
        let sub = 0;
        items.forEach(item => {
            const price = parseFloat(item.effectivePrice) || parseFloat(item.price) || 0;
            const qty = item.quantity || 1;
            sub += price * qty;
        });
        setSubTotal(sub);
        const gst = sub * 0.05;
        setGstTotal(gst);
        const service = sub * 0.1;
        setServiceCharges(service);
        const total = sub + gst + (serviceApplied ? service : 0) - discountAmount;
        setGrandTotal(total);
        const allItemsReady = items.length > 0 && items.every(item => item.orderStatus === "COMPLETED");
        setAllReady(allItemsReady);
    }, [serviceApplied, discountAmount]);

    // ✅ Always fetch cart on mount
    useEffect(() => {
        fetchCartDetails();
        fetchWalletData();
    }, [fetchCartDetails, fetchWalletData]);

    useEffect(() => {
        if (cartItems.length > 0) calculateTotals(cartItems);
    }, [cartItems, calculateTotals]);

    const handleCategoryClick = (cat) => {
        setSelectedCategory(cat.categoryName);
        setParentId(cat.categoryName === "ALL" ? null : cat.dishId);
        setIsVegSelected(false);
        setIsNonVegSelected(false);
    };

    const handleToggleTooltip = (dishId, desc) => {
        setActiveTooltip(activeTooltip === dishId ? null : dishId);
        setDescription(desc || "");
    };

    const addToCart = async (dish, quantity = 1) => {
        const { userId, token } = getAuthVars();
        if (!userId || !token) {
            toast.error("Please login first");
            if (setShowLogin) setShowLogin(true);
            return;
        }
        if (!currentSeatingId) {
            toast.error("No active table session. Please select table first.");
            return;
        }
        setCartLoading(true);
        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/cart/add/item`,
                { dishId: dish.dishId, quantity },
                {
                    params: { userId: Number(userId), seatingId: Number(currentSeatingId) },
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
                }
            );
            if (response.status === 200 || response.status === 201) {
                toast.success(`${dish.dishName} added to cart!`);
                await fetchCartDetails();
                if (isMobile) setIsCartPanelOpen(true);
            }
        } catch (error) {
            let errorMessage = error.response?.data?.message || error.response?.data?.error || "Failed to add to cart";
            if (errorMessage === "Seating not found") {
                setCurrentSeatingId(null);
                errorMessage = "Table session expired. Please select table again.";
            }
            toast.error(errorMessage);
        } finally {
            setCartLoading(false);
        }
    };

    const removeCartItem = async (item) => {
        const { userId, token } = getAuthVars();
        if (!item?.itemId) return;
        try {
            const response = await axios.delete(
                `https://backend.maamaas.com/food/api/cart/remove/item?userId=${userId}&itemId=${item.itemId}`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (response.status === 200) {
                await fetchCartDetails();
                toast.success(`${item.dishName} removed`);
            }
        } catch {
            toast.error("Failed to remove item");
        }
    };
const updateCartItem = async (item, newQuantity) => {
    const { userId, token } = getAuthVars();

    const itemId = item.itemId || item.id;
    const previousQuantity = Number(item.quantity ?? 1);

    console.log("FINAL DEBUG:", {
        userId,
        itemId,
        quantity: newQuantity,
        previousQuantity
    });

    try {
        return await axios.put(
            "https://backend.maamaas.com/food/api/cart/update/item",
            {}, // empty body
            {
                params: {
                    userId: Number(userId),
                    itemId: Number(itemId),
                    quantity: Number(newQuantity),
                    previousQuantity: previousQuantity   // 🔥🔥 ADD THIS
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            }
        );

    } catch (error) {
        console.log("UPDATE ERROR:", error?.response?.data);
        throw error;
    }
};
    const incrementQuantity = async (item) => {
    const currentQty = quantities[item.itemId] || item.quantity || 1;
    const newQuantity = currentQty + 1;

    try {
        const res = await updateCartItem(item, newQuantity);

        if (res.status === 200) {
            setQuantities(prev => ({
                ...prev,
                [item.itemId]: newQuantity
            }));

            await fetchCartDetails(); // optional (can optimize later)
        }

    } catch {
        toast.error("Failed to update quantity");
    }
};
    const decrementQuantity = async (item) => {
    const currentQty = quantities[item.itemId] || item.quantity || 1;

    if (currentQty === 1) {
        await removeCartItem(item);
        return;
    }

    const newQuantity = currentQty - 1;

    try {
        const res = await updateCartItem(item, newQuantity);

        if (res.status === 200) {
            setQuantities(prev => ({
                ...prev,
                [item.itemId]: newQuantity
            }));

            await fetchCartDetails();
        }

    } catch {
        toast.error("Failed to update quantity");
    }
};
    const handleSendToChef = async (item) => {
    try {
        const currentQty = quantities[item.itemId] || item.quantity || 1;

        const res = await updateCartItem(item, currentQty);

        if (res.status === 200) {
            toast.success(`${item.dishName} sent to kitchen!`);
            await fetchCartDetails();
        }

    } catch {
        toast.error("Failed to send to kitchen");
    }
};

    const handleAddToFavorites = async (dishId) => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        if (!userId || !token) { toast.error("Please log in first."); return; }
        if (favorites.includes(dishId)) { toast.info("Already in favorites!"); return; }
        try {
            const response = await fetch(
                `https://backend.maamaas.com/food/api/favourite/add/${userId}/${dishId}`,
                { method: "POST", headers: { Authorization: `Bearer ${token}` } }
            );
            if (response.ok || response.status === 409) {
                setFavorites(prev => [...new Set([...prev, dishId])]);
                toast.success("Added to favorites!");
            }
        } catch {
            toast.error("Network error.");
        }
    };

    const handleClearCart = async () => {
        const { userId, token } = getAuthVars();
        if (!userId) { toast.error("User ID not found!"); return; }
        try {
            const response = await axios.delete(
                `https://backend.maamaas.com/food/api/cart/delete/user/cart?userId=${userId}`,
                { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } }
            );
            if (response.status === 200) {
                toast.success("Cart cleared!");
                setCartItems([]);
                setQuantities({});
                setGrandTotal(0); setSubTotal(0); setGstTotal(0);
                setDiscountAmount(0); setAppliedCoupon(false); setCouponId(null);
                setShowPaymentOptions(false); setSelectedPaymentMethod(null);
                localStorage.removeItem("cartId");
                await fetchCartDetails();
            }
        } catch {
            toast.error("Failed to clear cart");
        }
    };

    const toggleServiceCharges = async () => {
        const cartIdLocal = localStorage.getItem("cartId");
        const token = localStorage.getItem("authToken");
        const newStatus = serviceApplied ? "NOT_APPLICABLE" : "APPLICABLE";
        try {
            await axios.put(
                `https://backend.maamaas.com/food/api/cart/coupon/${cartIdLocal}`,
                { serviceCharge: newStatus },
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            setServiceApplied(!serviceApplied);
            toast.success(`Service charges ${serviceApplied ? "removed" : "applied"}`);
            await fetchCartDetails();
        } catch {
            toast.error("Failed to update service charges");
        }
    };

    const handleShowGST = async () => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        try {
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/cart/${userId}/with-seating`,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            const gstObj = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : {};
            setGstBreakdownData({
                serviceChargeGst: gstObj.serviceChargeGst ?? 0,
                platformChargeGst: gstObj.platformChargeGst ?? 0,
                cgst: gstObj.cgst ?? 0,
                sgst: gstObj.sgst ?? 0,
            });
            setShowGstPopup(true);
        } catch {
            toast.error("Failed to fetch GST details");
        }
    };

    const openScheduleModal = () => {
        setScheduleDate(""); setScheduleTime(""); setGuestName(""); setPhoneNumber("");
        setNumberOfGuests(2); setDurationMinutes(2); setBookingSuccess(false); setWaitingListMessage(null);
        setIsScheduleModalOpen(true);
    };

    const handleScheduleConfirm = async () => {
        if (bookingLoading) return;
        if (!scheduleDate || !scheduleTime || !guestName?.trim() || !phoneNumber?.trim() || phoneNumber.length < 10 || numberOfGuests < 1) {
            toast.error("Please fill all required fields correctly"); return;
        }
        const { userId, token, vendorId } = getAuthVars();
        if (!userId || !token || !vendorId) { toast.error("Please login first"); return; }
        setBookingLoading(true);
        try {
            const payload = {
                startTime: scheduleTime + ":00", durationMinutes: Number(durationMinutes),
                phoneNumber: phoneNumber.trim(), guestName: guestName.trim(),
                bookingDate: scheduleDate, arrivalStatus: "ARRIVED", types: "BOOK_NOW",
                capacity: Number(numberOfGuests), seatingId: 0, vendorId: Number(vendorId)
            };
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/seatingdetails/shedule/advance/booking/${userId}/${vendorId}`,
                payload,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            if (response.status === 200 || response.status === 201) {
                const responseData = response.data;
                if ((typeof responseData === 'string' && responseData.toLowerCase().includes('waiting')) ||
                    (responseData?.message && responseData.message.toLowerCase().includes('waiting')) ||
                    responseData?.waitingList === true) {
                    setWaitingListMessage(responseData?.message || responseData || "Added to waiting list.");
                } else {
                    setBookingSuccess(true);
                    setBookingDetails({ bookingId: responseData?.id || responseData?.bookingId, guestName, phoneNumber, numberOfGuests, date: scheduleDate, time: scheduleTime, durationMinutes });
                    toast.success(`Table booked for ${guestName} 🎉`);
                }
            }
        } catch (error) {
            const errorData = error.response?.data;
            if ((typeof errorData === 'string' && errorData.toLowerCase().includes('waiting')) ||
                (errorData?.message && errorData.message.toLowerCase().includes('waiting')) ||
                errorData?.waitingList === true) {
                setWaitingListMessage(errorData?.message || errorData || "Added to waiting list.");
            } else {
                toast.error(errorData?.message || "Booking failed");
            }
        } finally {
            setBookingLoading(false);
        }
    };

    const handleCheckoutClick = async () => {
        if (!selectedPaymentMethod) { toast.error("Please select a payment method"); return; }
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken");
        const cartIdLocal = cartId || localStorage.getItem("cartId");
        setOrderPlacing(true);
        try {
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/orders/orders/create/${cartIdLocal}`,
                null,
                {
                    params: { userId: parseInt(userId), cartId: cartIdLocal, paymentMethod: selectedPaymentMethod, walletType: selectedPaymentMethod === "Maamaas_Wallet" ? selectedWalletType : null },
                    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }
                }
            );
            if (response.status === 200 || response.status === 201) {
                setOrderId(response.data?.orderId);
                setShowPaymentData(true);
                setShowPaymentOptions(false);
                toast.success("Order placed successfully!");
                await fetchCartDetails();
            }
        } catch (error) {
            toast.error(error.response?.data?.message || "Failed to place order");
        } finally {
            setOrderPlacing(false);
        }
    };

    const handleCheckboxChange = (method, isChecked) => {
        if (isChecked) {
            setIsWalletChecked(method === "wallet");
            setIsCashChecked(method === "cash");
            setIsOnlineChecked(method === "online");
            setSelectedPaymentMethod(method === "wallet" ? "Maamaas_Wallet" : method === "cash" ? "Cash" : "Online_Payment");
            setShowWalletOptions(method === "wallet");
        } else if (method === "wallet") {
            setIsWalletChecked(false);
            setShowWalletOptions(false);
            setSelectedPaymentMethod(null);
        }
    };

    const getTotalItems = () => cartItems.reduce((t, i) => t + (i.quantity || 1), 0);
    const cartItemsCount = getTotalItems();

    if (loading) return (
        <div className="menu-loading">
            <div className="menu-loading-spinner"/>
            <span>Loading Menu...</span>
        </div>
    );
    if (error) return <div className="menu-error">Error: {error.message}</div>;

    // ─── CART SIDEBAR ────────────────────────────────────────────────────────
    const CartSidebar = ({ isMobileView, onClose }) => (
        <div className={`cart-sidebar ${isMobileView ? 'cart-sidebar--mobile' : 'cart-sidebar--desktop'}`}>
            {/* Cart Header */}
            <div className="cart-header">
                <div className="cart-header-left">
                    <ShoppingCartIcon />
                    <span className="cart-title">Your Cart</span>
                    <span className="cart-badge">{cartItemsCount}</span>
                </div>
                <div className="cart-header-right">
                    {cartItems.length > 0 && (
                        <button className="cart-clear-btn" onClick={handleClearCart}>Clear All</button>
                    )}
                    {isMobileView && (
                        <button className="cart-close-btn" onClick={onClose}><CloseIcon /></button>
                    )}
                </div>
            </div>

            {/* Table Info Banner */}
            {(tableCode || currentSeatingId) && (
                <div className="cart-table-banner">
                    <span>🍽️ Table: <strong>{tableCode || '—'}</strong></span>
                    {currentSeatingId && <span className="cart-session-badge">Active Session</span>}
                </div>
            )}

            {/* No table selected notice */}
            {!currentSeatingId && (
                <div className="cart-no-table-notice">
                    <span>📋 No table selected yet</span>
                    <p>Select a table to start adding items to cart</p>
                    <button className="cart-book-btn" onClick={openScheduleModal}>Book a Table</button>
                </div>
            )}

            {/* Cart Body */}
            <div className="cart-body">
                {showPaymentData ? (
                    <div className="cart-order-success">
                        <div className="cart-success-icon">✅</div>
                        <h3>Order Placed!</h3>
                        <p>Order ID: <strong>{orderId}</strong></p>
                        <button className="cart-continue-btn" onClick={() => { setShowPaymentData(false); fetchCartDetails(); if (onClose) onClose(); }}>
                            Continue Shopping
                        </button>
                    </div>
                ) : cartItems.length === 0 ? (
                    <div className="cart-empty">
                        <div className="cart-empty-icon">
                            <ShoppingCartIcon />
                        </div>
                        <p>Your cart is empty</p>
                        <span>Add delicious items from the menu</span>
                    </div>
                ) : (
                    <>
                        {/* Cart Items */}
                        <div className="cart-items-list">
                            {cartItems.map(item => {
                                const qty = item.quantity || 1;
                                const price = parseFloat(item.effectivePrice) || parseFloat(item.price) || 0;
                                const itemId = item.itemId || item.cartItemId;
                                const isCompleted = item.orderStatus === "COMPLETED";
                                return (
                                    <div key={itemId} className="cart-item">
                                        <div className="cart-item-top">
                                            <img
                                                src={item.dishImage || 'https://via.placeholder.com/50'}
                                                alt={item.dishName}
                                                className="cart-item-img"
                                                onError={e => { e.target.src = 'https://via.placeholder.com/50'; }}
                                            />
                                            <div className="cart-item-info">
                                                <div className="cart-item-name">{item.dishName}</div>
                                                <div className="cart-item-price">₹{price.toFixed(2)}</div>
                                                {isCompleted && <div className="cart-item-sent">✓ Sent to kitchen</div>}
                                            </div>
                                            <div className="cart-qty-controls">
                                                <button className="cart-qty-btn" onClick={() => decrementQuantity(item)}>
                                                    {qty === 1 ? '🗑' : '−'}
                                                </button>
                                                <span className="cart-qty-num">{qty}</span>
                                                <button className="cart-qty-btn" onClick={() => incrementQuantity(item)}>+</button>
                                            </div>
                                        </div>
                                        {!isCompleted && (
                                            <div className="cart-item-actions">
                                                <input
                                                    type="text"
                                                    placeholder="Special instructions..."
                                                    value={notes[itemId] || ""}
                                                    onChange={e => setNotes(prev => ({ ...prev, [itemId]: e.target.value }))}
                                                    className="cart-note-input"
                                                />
                                                <button className="cart-send-btn" onClick={() => handleSendToChef(item)}>
                                                    Send
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                        {/* Bill Summary */}
                        <div className="cart-summary">
                            <div className="cart-summary-row">
                                <span>Sub Total</span>
                                <span>₹{subTotal.toFixed(2)}</span>
                            </div>
                            <div className="cart-summary-row">
                                <span>
                                    GST{' '}
                                    <BsInfoCircleFill onClick={handleShowGST} style={{ fontSize: '11px', cursor: 'pointer', color: '#ee6521' }} />
                                </span>
                                <span>₹{gstTotal.toFixed(2)}</span>
                            </div>
                            <div className="cart-summary-row">
                                <span>
                                    Service Charges
                                    <button className="cart-toggle-service" onClick={toggleServiceCharges}>
                                        {serviceApplied ? 'Remove' : 'Apply'}
                                    </button>
                                </span>
                                <span>₹{serviceCharges.toFixed(2)}</span>
                            </div>
                            {discountAmount > 0 && (
                                <div className="cart-summary-row cart-discount-row">
                                    <span>Discount</span>
                                    <span>−₹{discountAmount.toFixed(2)}</span>
                                </div>
                            )}
                            <div className="cart-summary-total">
                                <span>Grand Total</span>
                                <span>₹{grandTotal.toFixed(2)}</span>
                            </div>
                        </div>

                        {/* Payment Section */}
                        {!showPaymentOptions ? (
                            <button
                                onClick={() => setShowPaymentOptions(true)}
                                disabled={!allReady}
                                className={`cart-bill-btn ${allReady ? 'cart-bill-btn--active' : 'cart-bill-btn--disabled'}`}
                            >
                                {allReady ? '🧾 Generate Bill' : '⏳ Wait for all items to be sent'}
                            </button>
                        ) : (
                            <div className="cart-payment-section">
                                <div className="cart-payment-title">Select Payment Method</div>
                                <div className="cart-payment-options">
                                    <div className={`cart-payment-option ${selectedPaymentMethod === 'Maamaas_Wallet' ? 'selected' : ''}`}
                                        onClick={() => handleCheckboxChange('wallet', !isWalletChecked)}>
                                        <input type="checkbox" checked={isWalletChecked} onChange={e => handleCheckboxChange('wallet', e.target.checked)} />
                                        <span>👛 Wallet (₹{availableBalance.toFixed(2)})</span>
                                    </div>
                                    {showWalletOptions && (
                                        <div className="cart-wallet-options">
                                            <label><input type="radio" name="walletType" value="self" checked={selectedWalletType === "self"} onChange={e => setSelectedWalletType(e.target.value)} /> Self (₹{availableSelf.toFixed(2)})</label>
                                            <label><input type="radio" name="walletType" value="company" checked={selectedWalletType === "company"} onChange={e => setSelectedWalletType(e.target.value)} /> Company (₹{availableCompany.toFixed(2)})</label>
                                            <label><input type="radio" name="walletType" value="cashback" checked={selectedWalletType === "cashback"} onChange={e => setSelectedWalletType(e.target.value)} /> Cashback (₹{availableCashback.toFixed(2)})</label>
                                        </div>
                                    )}
                                    <div className={`cart-payment-option ${selectedPaymentMethod === 'Cash' ? 'selected' : ''}`}
                                        onClick={() => handleCheckboxChange('cash', !isCashChecked)}>
                                        <input type="checkbox" checked={isCashChecked} onChange={e => handleCheckboxChange('cash', e.target.checked)} />
                                        <span>💵 Cash</span>
                                    </div>
                                    <div className={`cart-payment-option ${selectedPaymentMethod === 'Online_Payment' ? 'selected' : ''}`}
                                        onClick={() => handleCheckboxChange('online', !isOnlineChecked)}>
                                        <input type="checkbox" checked={isOnlineChecked} onChange={e => handleCheckboxChange('online', e.target.checked)} />
                                        <span>💳 Online Payment</span>
                                    </div>
                                </div>
                                <button
                                    onClick={handleCheckoutClick}
                                    disabled={orderPlacing || !selectedPaymentMethod || (selectedPaymentMethod === 'Maamaas_Wallet' && !selectedWalletType)}
                                    className="cart-pay-btn"
                                >
                                    {orderPlacing ? 'Processing...' : 'Pay Now'}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );

    return (
        <div className="menu-page-wrapper">
            {/* ── LEFT: Menu Content ── */}
            <div className="menu-content">
                {/* Header Banner (table selected) */}
                {isFromAddItem && seatingContext && (
                    <div className="menu-table-banner">
                        <div>
                            <span className="menu-table-name">🍽️ Table: {seatingContext.tableCode}</span>
                            <span className="menu-table-guest">👤 {seatingContext.guestName}</span>
                        </div>
                        <button className="menu-view-bookings-btn" onClick={() => navigate('/Myordermain')}>
                            View Bookings →
                        </button>
                    </div>
                )}

                {/* Filter Bar */}
                <div className="menu-filter-bar">
                    <div className="menu-filter-left">
                        <span className="menu-filter-label">Filters</span>
                        {(searchTerm || isVegSelected || isNonVegSelected || selectedCategory !== "ALL") && (
                            <button className="menu-clear-filters" onClick={() => {
                                setSearchTerm(""); setIsVegSelected(false); setIsNonVegSelected(false);
                                setSelectedCategory("ALL"); setParentId(null);
                            }}>✕ Clear</button>
                        )}
                    </div>
                    <div className="menu-filter-right">
                        <input
                            type="text"
                            placeholder="Search dish..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            className="menu-search-input"
                        />
                        <button
                            className={`menu-chip menu-chip--veg ${isVegSelected ? 'active' : ''}`}
                            onClick={() => { setIsVegSelected(!isVegSelected); setIsNonVegSelected(false); }}
                        >🌱 Veg</button>
                        <button
                            className={`menu-chip menu-chip--nonveg ${isNonVegSelected ? 'active' : ''}`}
                            onClick={() => { setIsNonVegSelected(!isNonVegSelected); setIsVegSelected(false); }}
                        >🍗 Non-Veg</button>
                        <button className="menu-schedule-btn" onClick={openScheduleModal}>📅 Book Table</button>
                    </div>
                </div>

                {/* Categories */}
                <div className="menu-categories-section">
                    <h3 className="menu-section-title">Explore Categories</h3>
                    {categoriesLoading ? (
                        <p className="menu-loading-text">Loading categories...</p>
                    ) : (
                        <div className="menu-categories-scroll">
                            {[{ categoryName: 'ALL', dishId: null, image: 'https://cdn-icons-png.flaticon.com/512/1046/1046784.png' }, ...categories].map(cat => (
                                <div key={cat.categoryName} className="menu-category-item" onClick={() => handleCategoryClick(cat)}>
                                    <div className={`menu-category-img-wrap ${selectedCategory === cat.categoryName ? 'active' : ''}`}>
                                        <img
                                            src={cat.image}
                                            alt={cat.categoryName}
                                            onError={e => e.target.src = "https://cdn-icons-png.flaticon.com/512/1046/1046784.png"}
                                        />
                                    </div>
                                    <p style={{
      fontSize: '12px',
      fontWeight: selectedCategory === cat.dishId ? '600' : '400',
      color: selectedCategory === cat.dishId ? '#ee6521' : '#333',
      margin: 0,
      textAlign: 'center'
    }}>
      {cat.categoryName === 'ALL'
        ? 'All'
        : (cat.dishName?.length > 12
            ? cat.dishName.slice(0, 10) + '...'
            : cat.dishName)}
    </p>

                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {/* Dishes Grid */}
                <div className="menu-dishes-grid">
                    {filteredDishes.map(item => {
                        const isOutOfStock = Number(item.balanceQuantity) <= 0;
                        return (
                            <div key={item.dishId} className="menu-dish-card">
                                {/* Favorite button */}
                                <button
                                    className="dish-fav-btn"
                                    onClick={e => { e.stopPropagation(); handleAddToFavorites(item.dishId); }}
                                >
                                    <i className={`fa-${favorites.includes(item.dishId) ? 'solid' : 'regular'} fa-heart`}
                                        style={{ color: favorites.includes(item.dishId) ? '#dc2626' : '#ee6521' }} />
                                </button>

                                <img
                                    src={item.dishImage || "https://via.placeholder.com/300x180"}
                                    alt={item.dishName}
                                    className="dish-img"
                                />

                                <div className="dish-body">
                                    <div className="dish-name-row">
                                        <h5 className="dish-name">{item.dishName}</h5>
                                        <button
                                            className="dish-info-btn"
                                            onClick={e => { e.stopPropagation(); handleToggleTooltip(item.dishId, item.description); }}
                                        >i</button>
                                        <span className={`dish-tag-dot ${item.tag === 'Veg' ? 'veg' : 'nonveg'}`} />
                                    </div>

                                    {activeTooltip === item.dishId && (
                                        <div className="dish-tooltip">{description || 'No description available.'}</div>
                                    )}

                                    <div className="dish-price-row">
                                        {item.effectivePrice !== undefined && item.effectivePrice > 0 ? (
                                            <>
                                                <span className="dish-price-original">₹{item.price}</span>
                                                <span className="dish-price-effective">₹{item.effectivePrice.toFixed(2)}</span>
                                            </>
                                        ) : (
                                            <span className="dish-price-effective">₹{item.price}</span>
                                        )}
                                    </div>

                                    {isFromAddItem && currentSeatingId ? (
                                        <button
                                            onClick={() => addToCart(item)}
                                            disabled={isOutOfStock || cartLoading}
                                            className={`dish-add-btn ${(isOutOfStock || cartLoading) ? 'disabled' : ''}`}
                                        >
                                            <ShoppingCartIcon />
                                            {isOutOfStock ? 'Out of Stock' : cartLoading ? 'Adding...' : 'Add to Cart'}
                                        </button>
                                    ) : (
                                        <button className="dish-book-btn" onClick={openScheduleModal}>
                                            Book Table
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {/* ── RIGHT: Cart Sidebar — ALWAYS VISIBLE on Desktop ── */}
            {!isMobile && (
                <div className="cart-desktop-wrapper">
                    <CartSidebar isMobileView={false} />
                </div>
            )}

            {/* ── MOBILE: Floating Cart Button ── */}
            {isMobile && !showPaymentData && (
                <button className="cart-fab" onClick={() => setIsCartPanelOpen(true)}>
                    <ShoppingCartIcon />
                    {cartItemsCount > 0 && <span className="cart-fab-badge">{cartItemsCount}</span>}
                </button>
            )}

            {/* ── MOBILE: Cart Drawer ── */}
            {isMobile && isCartPanelOpen && (
                <>
                    <div className="cart-overlay" onClick={() => setIsCartPanelOpen(false)} />
                    <CartSidebar isMobileView={true} onClose={() => setIsCartPanelOpen(false)} />
                </>
            )}

            {/* ── GST Popup ── */}
            {showGstPopup && gstBreakdownData && (
                <div className="popup-overlay" onClick={() => setShowGstPopup(false)}>
                    <div className="popup-box" onClick={e => e.stopPropagation()}>
                        <h3 className="popup-title">GST Breakdown</h3>
                        {gstBreakdownData.serviceChargeGst > 0 && <div className="popup-row"><span>Service Charge GST</span><span>₹{gstBreakdownData.serviceChargeGst.toFixed(2)}</span></div>}
                        {gstBreakdownData.platformChargeGst > 0 && <div className="popup-row"><span>Platform Charge GST</span><span>₹{gstBreakdownData.platformChargeGst.toFixed(2)}</span></div>}
                        {gstBreakdownData.cgst > 0 && <div className="popup-row"><span>CGST</span><span>₹{gstBreakdownData.cgst.toFixed(2)}</span></div>}
                        {gstBreakdownData.sgst > 0 && <div className="popup-row"><span>SGST</span><span>₹{gstBreakdownData.sgst.toFixed(2)}</span></div>}
                        <div className="popup-total">
                            <span>Total GST</span>
                            <span>₹{(gstBreakdownData.cgst + gstBreakdownData.sgst + gstBreakdownData.serviceChargeGst + gstBreakdownData.platformChargeGst).toFixed(2)}</span>
                        </div>
                        <button className="popup-close-btn" onClick={() => setShowGstPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            {/* ── Schedule Modal ── */}
            {isScheduleModalOpen && (
                <div className="popup-overlay">
                    <div className="popup-box popup-box--lg">
                        {waitingListMessage ? (
                            <div className="booking-result">
                                <div className="booking-result-icon">⏳</div>
                                <h2 className="booking-result-title waiting">Added to Waiting List</h2>
                                <div className="booking-result-msg">{waitingListMessage}</div>
                                <p className="booking-result-sub">You'll be notified when a table is available.</p>
                                <button className="popup-close-btn" onClick={() => { setIsScheduleModalOpen(false); setWaitingListMessage(null); navigate('/Myordermain'); }}>View My Bookings</button>
                            </div>
                        ) : bookingSuccess ? (
                            <div className="booking-result">
                                <div className="booking-result-icon">✅</div>
                                <h2 className="booking-result-title success">Table Booked!</h2>
                                <div className="booking-details-grid">
                                    <div className="booking-detail"><span>Guest</span><strong>{bookingDetails?.guestName}</strong></div>
                                    <div className="booking-detail"><span>Phone</span><strong>{bookingDetails?.phoneNumber}</strong></div>
                                    <div className="booking-detail"><span>Guests</span><strong>{bookingDetails?.numberOfGuests}</strong></div>
                                    <div className="booking-detail"><span>Date</span><strong>{bookingDetails?.date}</strong></div>
                                    <div className="booking-detail"><span>Time</span><strong>{bookingDetails?.time}</strong></div>
                                    <div className="booking-detail"><span>Duration</span><strong>{bookingDetails?.durationMinutes} hrs</strong></div>
                                </div>
                                <button className="popup-close-btn" onClick={() => { setIsScheduleModalOpen(false); setBookingSuccess(false); navigate('/Myordermain'); }}>View My Bookings</button>
                            </div>
                        ) : (
                            <>
                                <h3 className="popup-title">📅 Book a Table</h3>
                                <div className="schedule-form">
                                    <input type="text" placeholder="Full Name *" value={guestName} onChange={e => setGuestName(e.target.value)} className="schedule-input" />
                                    <input type="tel" placeholder="Phone Number *" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} className="schedule-input" />
                                    <div className="schedule-row">
                                        <input type="number" placeholder="Guests" value={numberOfGuests} onChange={e => setNumberOfGuests(parseInt(e.target.value) || 1)} className="schedule-input" />
                                        <input type="number" placeholder="Duration (Hours)" value={durationMinutes} onChange={e => setDurationMinutes(parseInt(e.target.value) || 1)} className="schedule-input" />
                                    </div>
                                    <div className="schedule-row">
                                        <input type="date" value={scheduleDate} onChange={e => setScheduleDate(e.target.value)} min={new Date().toISOString().split("T")[0]} className="schedule-input" />
                                        <input type="time" value={scheduleTime} onChange={e => setScheduleTime(e.target.value)} className="schedule-input" />
                                    </div>
                                    <div className="schedule-actions">
                                        <button className="schedule-cancel-btn" onClick={() => setIsScheduleModalOpen(false)}>Cancel</button>
                                        <button className="schedule-confirm-btn" onClick={handleScheduleConfirm} disabled={bookingLoading}>
                                            {bookingLoading ? 'Booking...' : 'Confirm Booking'}
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MenuitemsTable;